module.exports = __webpack_public_path__ + "static/media/06.532dd12c.jpg";